import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';

export default class RoadmapRoadmapVisualisationColumnIndexComponent extends Component {
  @service store;

  get config() {
    return this.args.bucketConfiguration ?? {};
  }

  get total_capacity() {
    return this.config.total_capacity;
  }

  get title() {
    return this.config.title;
  }

  get test_id() {
    return this.config.test_id;
  }

  get initiatives() {
    return this.config.initiatives ?? [];
  }

  get initiative_ids() {
    return this.initiatives.map((item) => item.id);
  }

  get boxes() {
    return this.config.boxes;
  }

  get source() {
    return this.config.source;
  }

  get overplanned() {
    return (
      +this.planned_capacity + +this.uncertain_capacity > this.total_capacity
    );
  }

  get planned_capacity() {
    return this.initiatives.reduce((acc, item) => {
      const pw = +item.person_weeks_excluding_uncertainty;
      if (!isNaN(pw)) return acc + pw;
      return acc;
    }, 0);
  }

  get uncertain_capacity() {
    return this.initiatives.reduce((acc, item) => {
      const pw = +item.person_weeks_only_uncertainty;
      if (!isNaN(pw)) return +acc + pw;
      return acc;
    }, 0);
  }

  get available_capacity() {
    return (
      this.total_capacity - this.planned_capacity - this.uncertain_capacity
    );
  }

  get reccomended_initiatives_count() {
    return this.args.initiativeOptions?.filter(
      (i) =>
        i.source === this.config.source && i?.recommended?.recommended === true,
    ).length;
  }

  get combinedBoxList() {
    let finalList = [];
    const initiatives = this.initiatives;
    const boxes = this.boxes;
    if (initiatives.length === 0) finalList = [...boxes];
    if (initiatives.length > boxes.length) {
      finalList = initiatives.map((initiative, index) => {
        const box = boxes.at(index);
        if (box) {
          initiative.color = box.color;
        } else {
          initiative.color = 'bg-red-600';
        }
        return initiative;
      });
    } else {
      finalList = this.boxes.map((box, index) => {
        const initiative = initiatives.at(index);
        if (initiative) {
          initiative.color = box.color;
          return initiative;
        }
        return box;
      });
    }
    return finalList;
  }

  get initiativesInSource() {
    return this.args.initiativeOptions.filter(
      (i) => i.source === this.config.source,
    ).length;
  }

  get unselectedInitiativesFilteredBySource() {
    const initiatives = this.args.initiativeOptions;
    const sourceFilteredInitiatives = initiatives
      .filter(
        (i) => i.source === this.source && !this.initiative_ids.includes(i.id),
      )
      .map((initiative) => ({ label: initiative.title, value: initiative.id }));
    return sourceFilteredInitiatives;
  }

  @action
  propagateInitiative(e) {
    this.args?.onInitiativeSelect(e);
  }
}
